import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { PRODUCT_ATTRIBUTES_FILTERS } from '@/types/FiltersConst';
import { ProductAttributes, ProductKeys } from '@/types/ProductEnums';
var nonFilters = ['page', 'sort', 'phrase', 'itemsPerPage'];
var reduceFilters = function reduceFilters(query) {
  return function (prev, curr) {
    var makeArray = Array.isArray(query[curr]) || nonFilters.includes(curr);
    return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, curr, makeArray ? query[curr] : [query[curr]]));
  };
};
var getQueryParameter = function getQueryParameter(item) {
  return Array.isArray(item) ? item[0] : item;
};
var getFiltersDataFromUrl = function getFiltersDataFromUrl(query, onlyFilters) {
  return Object.keys(query).filter(function (f) {
    return onlyFilters ? PRODUCT_ATTRIBUTES_FILTERS.includes(f) : nonFilters.includes(f);
  }).reduce(reduceFilters(query), {});
};
var getPageFromURL = function getPageFromURL(query) {
  return parseInt(getQueryParameter(query.page), 10) || 1;
};
var useUiHelpers = function useUiHelpers() {
  var route = useRoute();
  var query = route.query,
    params = route.params;
  var router = useRouter();
  var getFacetsFromURL = function getFacetsFromURL() {
    var country = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var defaultSorting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'latest';
    var querySort = Array.isArray(query.sort) ? query.sort[0] : query.sort;
    return {
      categorySlug: params.slug,
      page: getPageFromURL(query),
      sort: querySort || defaultSorting,
      filters: _objectSpread(_objectSpread({}, getFiltersDataFromUrl(query, true)), country ? _defineProperty({}, ProductAttributes.availableInCountries, [country, 'ALL']) : {}),
      itemsPerPage: parseInt(getQueryParameter(query.itemsPerPage), 10) || 18,
      phrase: query.phrase
    };
  };
  var getFacetsFromURLWithoutDiscontinuedProducts = function getFacetsFromURLWithoutDiscontinuedProducts() {
    var country = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var defaultSorting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var facets = getFacetsFromURL(country, defaultSorting);
    facets.filters[ProductKeys.isSellable] = [ProductKeys.inStock, ProductKeys.outOfStock];
    return facets;
  };

  // Check if we have pagination or filters applied
  var isUrlDirty = function isUrlDirty() {
    var page = getPageFromURL(query);
    var filters = getFiltersDataFromUrl(query, true);
    var firstPage = page === 1;
    var filtersEmpty = Object.values(filters).every(function (array) {
      return array.length === 0;
    });
    return !firstPage || !filtersEmpty;
  };
  var getCatLink = function getCatLink() {
    for (var _len = arguments.length, slugs = new Array(_len), _key = 0; _key < _len; _key++) {
      slugs[_key] = arguments[_key];
    }
    var categorySlugsPath = slugs.join('/');
    return "/c/".concat(route.params.slug, "/").concat(categorySlugsPath);
  };
  var changeSorting = function changeSorting(sort) {
    var oldQuery = _objectSpread({}, route.query);
    var queryUpdate = _objectSpread(_objectSpread({}, oldQuery), {}, {
      sort: sort
    });
    router.push({
      query: queryUpdate
    });
  };
  var changeFilters = function changeFilters(filters) {
    router.push({
      query: _objectSpread(_objectSpread({}, getFiltersDataFromUrl(query, false)), filters)
    });
  };
  var changeItemsPerPage = function changeItemsPerPage(itemsPerPage) {
    router.push({
      query: _objectSpread(_objectSpread({}, getFiltersDataFromUrl(query, false)), {}, {
        itemsPerPage: itemsPerPage
      })
    });
  };
  var setTermForUrl = function setTermForUrl(term) {
    router.push({
      query: _objectSpread(_objectSpread({}, getFiltersDataFromUrl(query, false)), {}, {
        phrase: term || undefined
      })
    });
  };
  var isFacetColor = function isFacetColor(facet) {
    return facet.id === 'color';
  };
  var isFacetCheckbox = function isFacetCheckbox() {
    return false;
  };
  var hasPageFacetChanged = function hasPageFacetChanged() {
    var oldPageFacet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var newPageFacet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    if (oldPageFacet.length !== newPageFacet.length) {
      return true;
    }
    if (oldPageFacet.length === 0 && newPageFacet.length === 0) {
      return false;
    }
    return oldPageFacet[0] !== newPageFacet[0];
  };
  return {
    getFacetsFromURL: getFacetsFromURL,
    getFacetsFromURLWithoutDiscontinuedProducts: getFacetsFromURLWithoutDiscontinuedProducts,
    isUrlDirty: isUrlDirty,
    getCatLink: getCatLink,
    changeSorting: changeSorting,
    changeFilters: changeFilters,
    changeItemsPerPage: changeItemsPerPage,
    setTermForUrl: setTermForUrl,
    isFacetColor: isFacetColor,
    isFacetCheckbox: isFacetCheckbox,
    hasPageFacetChanged: hasPageFacetChanged
  };
};
export default useUiHelpers;